import { ExpertiseEnum } from "@/lib/expertiseEnum";
import { TeamMemberEnum } from "@/lib/teamData";

export interface ExpertiseCityWiringEntry {
  teamMembers: TeamMemberEnum[];
}

const moritzOnly = [TeamMemberEnum.MoritzRiehl];
const hubiOnly = [TeamMemberEnum.HubertusScherbarth];
const hubiThenMoritz = [
  TeamMemberEnum.HubertusScherbarth,
  TeamMemberEnum.MoritzRiehl,
];
const moritzThenHubi = [
  TeamMemberEnum.MoritzRiehl,
  TeamMemberEnum.HubertusScherbarth,
];

function citiesWiring(
  slugs: readonly string[],
  teamMembers: TeamMemberEnum[],
): Partial<Record<string, ExpertiseCityWiringEntry>> {
  return Object.fromEntries(
    slugs.map((slug) => [slug, { teamMembers: [...teamMembers] }]),
  );
}

/** Team member enums per city slug (filename without .json). Court rows carry `enum` in JSON. */
export const expertiseCityWiring: Partial<
  Record<ExpertiseEnum, Partial<Record<string, ExpertiseCityWiringEntry>>>
> = {
  [ExpertiseEnum.Arbeitsrecht]: citiesWiring(
    [
      "kaiserslautern",
      "koblenz",
      "landau-pfalz",
      "muenchen",
      "pirmasens",
      "stuttgart",
    ],
    moritzOnly,
  ),
  [ExpertiseEnum.Erbrecht]: citiesWiring(
    [
      "kaiserslautern",
      "koblenz",
      "landau-pfalz",
      "muenchen",
      "pirmasens",
      "stuttgart",
    ],
    moritzOnly,
  ),
  [ExpertiseEnum.Gesellschaftsrecht]: {
    ...citiesWiring(
      [
        "heilbronn",
        "kaiserslautern",
        "koblenz",
        "koeln",
        "muenchen",
        "pirmasens",
        "stuttgart",
      ],
      hubiThenMoritz,
    ),
    "landau-pfalz": { teamMembers: [...moritzThenHubi] },
  },
  [ExpertiseEnum.Insolvenzrecht]: citiesWiring(
    ["koblenz", "koeln", "landau-pfalz"],
    hubiOnly,
  ),
  [ExpertiseEnum.InternetMedienRecht]: citiesWiring(
    ["kaiserslautern", "koblenz", "landau-pfalz", "muenchen", "stuttgart"],
    moritzThenHubi,
  ),
  [ExpertiseEnum.Prozessfuehrung]: citiesWiring(
    ["kaiserslautern", "koblenz", "landau-pfalz", "muenchen", "stuttgart"],
    moritzThenHubi,
  ),
  [ExpertiseEnum.Startuprecht]: citiesWiring(
    ["kaiserslautern", "koblenz", "landau-pfalz", "muenchen", "stuttgart"],
    moritzThenHubi,
  ),
  [ExpertiseEnum.Steuerrecht]: citiesWiring(
    ["kaiserslautern", "koblenz", "landau-pfalz", "muenchen", "stuttgart"],
    hubiOnly,
  ),
};
